<template>
    <div class="position-relative" style="z-index: 1;">
        <template v-if="events.length<=0">
            <draggable
                ghost-class="ghost"
                group="appointments"
                :list="events"
                @change="change($event, date)"
                :move="move"
                @start="startDragging()"
                @end="dragging = false"
            ></draggable>
        </template>
        <template v-else>
            <component
                @start="startDragging()"
                @end="dragging = false"
                ghost-class="ghost"
                :is="drag"
                group="appointments"
                :list="events"
            >
                <div v-for="(event, index) in events" :key="index" class="eventItem" :class="{singleMember:singleMember}">
                    <div
                        :id="id(event)"
                        :class="!event.isBlocker ?'card event eventMultiple' : 'card event blocker'"
                        :style="eventClass(duration(event.startAt, event.endAt), event)"
                    >
                        <div
                            class="row pl-1"
                            :style="' border-bottom:1px solid '+event.colors +'; background-color: ' + event.colors "
                        >
                            <div class="col text-left pr-0">
                                <span class="small block" v-if="event.customer">
                                    <!-- <avatar :src="event.customer.avatar.preview" type="circle" v-if="event.customer" size="avatar-xs"></avatar> -->
                                    {{ event.customer.first_name }}
                                    {{ event.customer.last_name }}
                                    <i
                                        class="fe fe-dollar-sign small text-white"
                                        v-if="event.customer.balance<0"
                                    />
                                    <!-- {{ event.startAt | moment("LT")}}-{{ event.endAt | moment("LT")}} -->
                                </span>
                            </div>
                            <div class="col-auto mr-1 pt-1" v-if="!event.isBlocker">
                                <div class="bg-white whiteCircle">
                                    <status-badge :status="event.status" :iconOnly="true" :noBadge="true"></status-badge>
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-1 m-0 text-left small bg-white">
                            <popover :id="id(event)" :event="event"></popover>

                            <div class="row align-items-center">
                                <div class="col card-text small" style="font-size:12px;">
                                    <div v-for="(service, serviceIndex ) in event.services" :key="serviceIndex">
                                        <span v-if="service.user">
                                            <span v-if="service.treatment">{{ service.treatment.label }}</span>
                                        </span>
                                    </div>
                                    <span class="text-muted">{{ event.notes }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </component>
        </template>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';


import Popover from './Popover.vue'
import duration from '@/filters/duration.js';
import draggable from 'vuedraggable'
import StatusBadge from '@/components/StatusBadge';

export default {
    props: {
        idExtraSuffix: String,
        events: Array,
        clickEvent: Function,
        date: null,
        change: Function,
        move: Function,
        singleMember: Boolean,
        step: Number,
        lineHeight: Number,
        lineWidth: Number
    },
    filters: { duration },

    components: {
        draggable,
        Avatar,
        Popover,
        StatusBadge,
    },
    computed: {
        statusList() {
            return statusList;
        },
        drag() {
            let check = this.$checkDevice();
            if (check) {
                return 'div';
            }
            return 'draggable';
        },
        leftMargins() {
            let result = {}
            Object.values(this.$groupBy(this.events, event => event.startAt)).forEach(group => {
                group.forEach((event, index) => {
                    const baseMargin = Math.floor((this.lineWidth / 2) / group.length);
                    result[event._id] = baseMargin * index
                })
            })
            return result
        }
    },
    data() {
        return {
            draggable: false,
            dragging: false,
        }
    },
    methods: {
        startDragging() {
            this.dragging = true;
            this.$root.$emit('bv::hide::popover');
        },

        id(event) {
            return 'popupover-' + event._id + this.idExtraSuffix;
        },

        eventClass(duration, event) {
            const topMargin = this.lineHeight * this.$moment(event.startAt).diff(this.date, 'minutes') / this.step;
            const leftMargin = this.leftMargins[event._id];
            const maxWidth = this.lineWidth ? this.lineWidth - leftMargin : 0;
            let slots = 0;
            let styles = [];

            slots = Math.ceil(this.lineHeight * duration / this.step);
            styles.push('height: ' + slots + 'px');
            styles.push('margin-top: ' + topMargin + 'px');
            styles.push('margin-left: ' + leftMargin + 'px');
            if (maxWidth)
                styles.push('max-width: ' + maxWidth + 'px');

            styles.push('border:1px solid ' + event.colors);
            // styles.push('border-right:3px solid ' + event.colors);
            // styles.push('border-left:3px solid ' + event.colors);
            // styles.push('border-bottom:2px solid ' + event.colors);
            // styles.push('background-color:' + event.colors);

            return styles.join(';')
        },
        duration(start, end) {
            let startTime = this.$moment(start);
            let endTime = this.$moment(end);
            return endTime.diff(startTime, 'minutes');
        }
    }
}
</script>

<style lang="scss">
.whiteCircle {
    height: 20px;
    width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    padding-bottom: 3px;
}

.singleMember .event {
    width: 100% !important;
}

.event {
    position: absolute;
    width: 80%;
    overflow: hidden;
}

.blocker .bg-white{
  background: linear-gradient(
          45deg
      , #ffffff 22%, #f4f4f4 22%, #f4f4f4 50%, #ffffff 50%, #ffffff 72%, #f4f4f4 72%, #f4f4f4 100%);
  background-size: 25px 25px
}

.user-1 {
    background-color: #ffefe6;
}

.event .badge {
    display: block;
    text-align: left;
    font-size: 12px;
}

.event:hover {
    position: absolute;
    -webkit-box-shadow: 8px 8px 7px -9px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 8px 8px 7px -9px rgba(0, 0, 0, 0.75);
    box-shadow: 8px 8px 7px -9px rgba(0, 0, 0, 0.75);
    z-index: 1000000;
    width: 100%;
    min-height: 30px;
}

//[class^="event-"], [class*=" event-"] {
//    border-left: 2px solid #fff !important;
//}

.eventMultiple {
    // border-radius: 15px;
    position: absolute;
    // width: 28px;
    // overflow: hidden;
}

.eventItem {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
